/** Lower-cased extension including the dot, e.g. "Lesson.PPTX" -> ".pptx". */
export const fileExtension = (filename: string): string =>
	('.' + (filename.split('.').pop() || '')).toLowerCase();

export const isValidUploadExtension = (filename: string, validExtensions: string[]): boolean =>
	validExtensions.includes(fileExtension(filename));
